import { createSelector } from '@reduxjs/toolkit'

import { getSession } from './recents'
import { getViewedSessionId } from './ui'
import envData from '~/core/env'

const getSessionOrViewedSession = id => state => getSession(id || getViewedSessionId(state))(state)

export const getViewedSession = state => getSession(getViewedSessionId(state))(state)
export const getSessionUrl = id => state => getSessionOrViewedSession(id)(state)?.url
export const getSessionParticipants = id => state => getSessionOrViewedSession(id)(state)?.resources.participants || []
export const getSessionJids = id => state => getSessionOrViewedSession(id)(state)?.jids
export const getSessionTranscript = id => state => getSessionOrViewedSession(id)(state)?.resources.transcript?.phrases || []
export const getSessionSummary = id => state => getSessionOrViewedSession(id)(state)?.resources.summary
export const getSessionActionItems = id => state => getSessionOrViewedSession(id)(state)?.resources.actionItems || []
export const getSessionChat = id => state => getSessionOrViewedSession(id)(state)?.resources.chat
export const getSessionLinks = id => state => getSessionOrViewedSession(id)(state)?.resources.links || []
export const getSessionPolls = id => state => getSessionOrViewedSession(id)(state)?.resources.polls || []
export const getSharingStatus = id => state => getSessionOrViewedSession(id)(state)?.resources.sharingStatus || {}
export const getSummaryFeedbackSubmitted = id => state => getSessionOrViewedSession(id)(state)?.summarySubmitted
export const getSharedFiles = id => state => getSessionOrViewedSession(id)(state)?.resources.sharedFiles

export const getSessionRecordings = id => createSelector(
  getSessionOrViewedSession(id),
  session => Object.values(session?.resources.recordings || {})
)

export const getSessionRecordingsWithHighlights = id => createSelector(
  getSessionRecordings(id),
  recordings => recordings.filter(rec => rec.keyMoments.length > 0)
)
export const getSessionRecordingsWithoutHighlights = id => createSelector(
  getSessionRecordings(id),
  recordings => recordings.filter(rec => rec.keyMoments.length === 0)
)

export const getAllSessionRecordingsCounter = id => createSelector(
  getSessionRecordings(id),
  recordings => recordings.reduce((counter, next) => counter + next.keyMoments.length + 1, 0)
)

export const getKeyMomentParentRecording = (sessionId, keyMomentUrl) => createSelector(
  getSessionRecordingsWithHighlights(sessionId),
  recordings => recordings.find(r => r.keyMoments.find(km => km.url === keyMomentUrl))
)

export const getSessionTime = id => createSelector(
  getSessionOrViewedSession(id),
  session => ({
    date: session.dateShort,
    interval: `${session.startTime} - ${session.endTime}`
  })
)

export const getSessionTopic = id => state => getSessionOrViewedSession(id)(state)?.topic

export const getLocationUrl = id => state => getSessionOrViewedSession(id)(state)?.locationUrl

export const getMostVotedOption = poll => {
  const { option, max } = poll.answers.reduce((res, answer) => {
    if (res.max < +answer.percent) {
      res.option = answer
      res.max = +answer.percent
    }
    return res
  }, { option: {}, max: -1 })

  if (!max) {
    return poll.answers[0]
  }

  return option
}

export const getSharingLink = id => state => getSharingStatus(id)(state).link
export const isSessionShared = id => state => getSharingStatus(id)(state).shared
export const getSessionSharer = id => state => getSharingStatus(id)(state).sharedBy

export const isVideoElevationMeeting = id => state => getSessionUrl(id)(state)?.includes(envData.videoElevationAppId)
